import { useRouter, matchPrefix } from "@/app/router";
import { useSession } from "@/app/session";
import { Spinner } from "@/components/ui";
import { ActivatePage, LoginPage, RegisterPage, ResetPasswordPage } from "@/features/auth/auth";
import { AppShell } from "@/app/AppShell";
import { SharedReportPage } from "@/features/reports/SharedReportPage";
import { InvitationPage } from "@/features/team/InvitationPage";

function FullSpinner() {
  return (
    <div className="flex min-h-full items-center justify-center">
      <Spinner className="size-6" />
    </div>
  );
}

export function App() {
  const { path } = useRouter();
  const { me, loading } = useSession();

  // Public routes render regardless of auth state.
  if (path.startsWith("/activate")) return <ActivatePage />;
  if (path.startsWith("/reset-password")) return <ResetPasswordPage />;
  if (matchPrefix(path, "shared") !== null) return <SharedReportPage />;
  if (matchPrefix(path, "invitations") !== null) return <InvitationPage />;

  if (loading) return <FullSpinner />;

  if (!me) {
    if (path === "/register") return <RegisterPage />;
    return <LoginPage />;
  }

  return <AppShell />;
}
